import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M5.755 15.765a7.8 7.8 0 0 1-.685-1.743 7.3 7.3 0 0 1-.232-1.834q0-3.245 2.258-5.522t5.492-2.278h.78l-1.85-1.85 1.054-1.054 3.654 3.654-3.654 3.654-1.053-1.054 1.85-1.85h-.781q-2.605 0-4.428 1.834-1.822 1.836-1.822 4.466 0 .621.135 1.241t.407 1.21zm6.848 7.027L8.95 19.138l3.654-3.654 1.054 1.054-1.85 1.85h.78q2.607 0 4.429-1.835t1.822-4.465a5.8 5.8 0 0 0-.136-1.241 6 6 0 0 0-.406-1.211L19.42 8.51a7.8 7.8 0 0 1 .685 1.743q.232.899.232 1.834 0 3.244-2.258 5.522t-5.492 2.278h-.78l1.85 1.85z'
    />
  </svg>
)
export default SvgComponent
